import domtoimage from '~/assets/js/dom-to-image'

export default (ctx, inject) => {
	inject('domtoimage', domtoimage)
}
